import { AdobeAnalyticsUtil } from '../../../../../../../../../Foundation/Common/code/Views/Foundation/Common/AdobeAnalytics/AdobeAnalyticsUtil.js';
import { getDeviceParameterData } from './Helpers.ts';
import { AddToCartButton, ProductData } from './Interfaces.ts';

export const TrackAddToCart = (addtoCartButton: AddToCartButton) => {
  let product = {
    id: addtoCartButton.productId,
    name: addtoCartButton.addToCartProductName,
    price: addtoCartButton.productPriceToPay,
    colour: addtoCartButton.colorspecification,
    original_price: addtoCartButton.originalPriceFormatted,
    category: addtoCartButton.category,
    subcategory: addtoCartButton.subcategory,
    over_category: addtoCartButton.overCategory,
    quantity: '1',
  };

  let analyticsData = {
    add_to_cart_variant: 'add_to_cart_comparison',
    products: [product],
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_addition', analyticsData);
};

export const TrackViewProduct = (productName: string) => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonTool?.subcategoryInfo.name,
    view_product: productName,
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_view_product ', comparison);
};

export const TrackModalOpen = () => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonModal?.SubcategoryName,
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_open', comparison);
};

export const TrackModalClose = (isLastProduct?: boolean) => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonModal?.SubcategoryName,
    close_type: isLastProduct ? 'X' : 'Button',
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_close', comparison);
};

export const TrackModalCloseFit = () => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonModal?.SubcategoryName,
    close_type: 'Fit',
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_close', comparison);
};

export const TrackPageClose = () => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonModal?.SubcategoryName,
    close_type: 'ComparePage',
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_close', comparison);
};

export const TrackCompare = (products: ProductData[]) => {
  if (isExtranet()) return;

  let comparison = {
    subcategory: window._THULEDATA.ComparisonModal?.SubcategoryName,
    number: `${products.length}`,
    compared_products: products.map((x) => x.webTitle1).join('|'),
    device: getDeviceParameterData(),
  };

  AdobeAnalyticsUtil.DataLayer.TrackEvent('comparison_tool_compare', comparison);
};

export const TrackCheckout = (products: never[]) => {
  if (isExtranet()) return;

  const analyticsData = {
    cart_type: 'minicart',
    products: products,
  };
  AdobeAnalyticsUtil.DataLayer.TrackEvent('initiate_checkout', analyticsData);
};

const isExtranet = () => {
  return window._THULEDATA.SitecoreSiteName.toLowerCase() === 'extranet';
};
